import React from 'react';
import { Check } from 'lucide-react';
export function TargetAudience() {
  const cards = [{
    icon: '🌱',
    title: 'Principiantes absolutos',
    desc: 'Nunca tocaste una guitarra o la tenés guardada juntando polvo. Guitarra Fácil PRO arranca literalmente desde cero: cómo agarrarla, cómo afinarla y tu primer acorde.',
    bullets: ['Postura, afinación y lectura de tablaturas desde cero', 'Progresión pensada para no frustrarte en la semana 1']
  }, {
    icon: '🔁',
    title: 'Los que empezaron y abandonaron',
    desc: 'Probaste con tutoriales sueltos, avanzaste un poco y lo dejaste porque no sabías qué seguía. Acá tenés el orden que te faltaba.',
    bullets: ['Ruta clara de tomo en tomo, sin saltos', 'Ejercicios de práctica diaria, no solo teoría']
  }, {
    icon: '👨‍👩‍👧',
    title: 'Padres que quieren sumar música en casa',
    desc: 'Buscás una actividad para tus hijos, o para hacer juntos, sin pagar clases particulares todas las semanas.',
    bullets: ['Explicaciones simples, aptas para adolescentes y adultos', 'Sin necesidad de leer partitura clásica']
  }];
  return <section className="w-full bg-fondo-principal text-white py-section px-4" data-id="element-171">
      <h2 className="text-2xl font-bold text-center mb-8" data-id="element-172">
        ¿Este método es para vos?
      </h2>
      <div className="flex flex-col gap-6" data-id="element-173">
        {cards.map((card, idx) => <div key={idx} className="bg-[#24180d] p-6 rounded-2xl border border-white/10" data-id="element-174">
            <div className="flex items-center gap-3 mb-4" data-id="element-175">
              <span className="text-2xl" data-id="element-176">{card.icon}</span>
              <h3 className="text-lg font-bold text-dorado-detalles" data-id="element-177">
                {card.title}
              </h3>
            </div>
            <p className="text-gray-300 mb-5 text-sm" data-id="element-178">{card.desc}</p>
            <ul className="space-y-3" data-id="element-179">
              {card.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-2 text-sm" data-id="element-180">
                  <Check className="w-5 h-5 text-botones-acentos shrink-0" data-id="element-181" />
                  <span data-id="element-182">{bullet}</span>
                </li>)}
            </ul>
          </div>)}
      </div>
    </section>;
}